/* globals __DEVELOPMENT__ */

import { createStore, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';

// Export middleware for tests
const middleware = [
  thunk,
  promiseMiddleware(),
];

if (__DEVELOPMENT__) {
  // middleware.push(createLogger());
}

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware),
  );

  if (module.hot) {
    // Enable hot module replacement for reducers
    module.hot.accept('../reducers/index.js', () => {
      const nextReducer = require('../reducers/index.js').default; // eslint-disable-line
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export {
  middleware,
};



// WEBPACK FOOTER //
// ./app/src/state/store/index.js